
export type QuickOrderPayload = {
  OrderAttachments: FileList[];
  UserName: string;
  ADLOrderID: number;
  RONo: string;
  PONo: string;
  TotalQty: number;
  Instructions: string;
  "CustomerInfo.CustomerInfoId": number;
  "CustomerInfo.ShopName": string;
  "CustomerInfo.FirstName": string;
  "CustomerInfo.LastName": string;
  "CustomerInfo.Email": string;
  "CustomerInfo.AccountNumber": string;
  "CustomerInfo.PhoneNumber": string;
  "ShippingInfo.ShippingInfoID": number;
  "ShippingInfo.AddressLine1": string;
  "ShippingInfo.AddressLine2": string;
  "ShippingInfo.StreetAddress": string;
  "ShippingInfo.City": string;
  "ShippingInfo.StateID": number;
  "ShippingInfo.StateName": string;
  "ShippingInfo.CountryID": number;
  "ShippingInfo.CountryName": string;
  "ShippingInfo.ZipCode": string;
  "ShippingInfo.CustomerInfoID": number;
  // ShippingInfo: {
  //     AddressLine1: string;
  //     AddressLine2: string;
  //     StreetAddress: string;
  //     City: string;
  //     StateID: number;
  //     StateName: string;
  //     CountryID: number;
  //     CountryName: string;
  //     ZipCode: string;
  //     CustomerInfoID: number;
  // }
  SourceID: number;
  StatusID: number;
  SourceEmail: string;
  IsOvernightDelivery: string;
  ShipViaPost: string;
  message?: string;
  error?: string;
  success?: string;
};

export interface FileList {
  fileName: string;
  orderAttachmentID: number;
  attachment: File;
  isEmailContent: boolean;
  isActive: boolean;
  imageQuality: "G" | "B" | "N" | "analyzing";
}

export interface UploadState {
  files: FileList[];
  duplicates: FileList[];
  invalids: FileList[];
  error: string | null;
}

export type UploadAction =
  | { type: "ADD_FILES"; payload: FileList[] }
  | { type: "REMOVE_FILE"; payload: FileList }
  | { type: "SET_FILES"; payload: FileList[] }
  | { type: "RESET_ERROR" }
  | {
      type: "UPDATE_FILE_CLARITY";
      payload: {
        fileName: string;
        size: number;
        imageQuality: "G" | "B" | "N";
      };
    };

export type QuickOrderState = {
  data: QuickOrderPayload;
  loading: boolean;
  success: boolean;
  error: string | null;
};
export const quickOrderDefaultValue: QuickOrderPayload = {
  OrderAttachments: [],
  UserName: "",
  RONo: "",
  PONo: "",
  TotalQty: 0,
  Instructions: "",
  IsOvernightDelivery: "USStandardDelivery",
  "CustomerInfo.CustomerInfoId": 0,
  "CustomerInfo.ShopName": "",
  "CustomerInfo.FirstName": "",
  "CustomerInfo.LastName": "",
  "CustomerInfo.Email": "",
  "CustomerInfo.AccountNumber": "",
  "CustomerInfo.PhoneNumber": "",
  "ShippingInfo.ShippingInfoID": 0,
  "ShippingInfo.AddressLine1": "",
  "ShippingInfo.AddressLine2": "",
  "ShippingInfo.StreetAddress": "",
  "ShippingInfo.City": "",
  "ShippingInfo.StateID": 0,
  "ShippingInfo.StateName": "",
  "ShippingInfo.CountryID": 0,
  "ShippingInfo.CountryName": "",
  "ShippingInfo.ZipCode": "",
  "ShippingInfo.CustomerInfoID": 0,
  // ShippingInfo: {
  //   AddressLine1: '',
  //   AddressLine2: '',
  //   StreetAddress: '',
  //   City: '',
  //   StateID: 0,
  //   StateName: '',
  //   CountryID: 0,
  //   CountryName: '',
  //   ZipCode: '',
  //   CustomerInfoID: 0,
  // },
  SourceID: 0,
  StatusID: 0,
  SourceEmail: "",
  ADLOrderID: 0,
  message: undefined,
  error: undefined,
  ShipViaPost: "CAStandardDelivery",
};
export const initialState: QuickOrderState = {
  data: quickOrderDefaultValue,
  loading: false,
  success: false,
  error: null,
};

export type QuickOrderServiceOperators = {
  quickOrder: QuickOrderPayload;
  submitQuickOrder: (data: QuickOrderPayload) => void;
  fetchQuickOrderData: (orderId: number) => void;
  updateQuickOrderData: (orderId: number, data: QuickOrderPayload) => void;
};
